export default __webpack_public_path__ + "e88df4cb3af8785a5f5abda31fdc7146.png";